(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halo-top-language"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  document.querySelectorAll('.choizin-language-picker[open], .choizin-help[open]').forEach((picker) => {
    if (!picker.contains(event.target)) picker.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.choizin-language-picker[open], .choizin-help[open]').forEach((picker) => {
    const hadFocus = picker.contains(document.activeElement);
    picker.removeAttribute('open');
    if (hadFocus) picker.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
